import React from 'react';

const SplashScreen = () => {
    return (
        <div className="screen splash-screen">
            <div className="splash-logo">
                <img src="/logo.jpg" alt="TransitEase Logo" className="splash-brand-logo" />
            </div>
        </div>
    );
};

export default SplashScreen;
